import Image2Column from './Image2Column';
import Image3Column from './Image3Column';
import ImageVertical2Column from './ImageVertical2Column';
import LifeStyle from './LifeStyle';
import ShopByConcern from './ShopByConcern';
import BeautyTools from './BeautyTools';
import Kbeauty from './Kbeauty';

export { Image2Column, Image3Column, ImageVertical2Column, LifeStyle, ShopByConcern, BeautyTools, Kbeauty };
